import clsx from 'clsx';
import { IconProps } from '.';
import { useIconStyle } from 'components/commons';

function AdvanceIcon({ className = '', style }: IconProps) {
  const classes = useIconStyle();

  return (
    <svg
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={clsx(classes.root, {
        [className]: className.length > 0,
      })}
      style={style}
    >
      <path
        fillRule='evenodd'
        d='M16 8C16 3.58149 12.4185 0 8 0C3.58149 0 0 3.58149 0 8C0 9.35857 0.339641 10.6699 0.97792 11.8361C1.46845 12.7316 2.1271 13.5264 2.91579 14.1773C4.33827 15.3484 6.11994 16 8 16C12.4185 16 16 12.4185 16 8ZM0.8 8C0.8 4.02331 4.02331 0.8 8 0.8C11.9767 0.8 15.2 4.02331 15.2 8C15.2 11.9767 11.9767 15.2 8 15.2C6.30724 15.2 4.70486 14.614 3.42464 13.56C2.71443 12.9739 2.12116 12.2579 1.67962 11.4518C1.10546 10.4028 0.8 9.22347 0.8 8Z'
        fill='currentColor'
      />
      <path
        d='M9.94029 8L6.45571 11.6585C6.38135 11.7366 6.38129 11.8632 6.45559 11.9414C6.52989 12.0195 6.6504 12.0196 6.72476 11.9415L10.3441 8.14148C10.4185 8.06336 10.4185 7.93664 10.3441 7.85852L6.72476 4.05852C6.6504 3.98045 6.52989 3.9805 6.45559 4.05864C6.38129 4.13678 6.38135 4.26341 6.45571 4.34148L9.94029 8Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.5'
      />
    </svg>
  );
}

export default AdvanceIcon;
